import { useStore } from '@nanostores/react'
import { useRef } from 'react'

import CountrySelect from '@/components/molecules/CountrySelect'
import Hubs from '@/components/organisms/Hubs'
import { useHeightObserver } from '@/hooks/useHeightObserver'
import { $language } from '@/stores/Language'
import { useMobileLayoutStore } from '@/stores/MobileLayoutStore'
import { cn } from '@/util/cn'

export default function ConfiguratorHeader() {
  const { isMobile, activeMobileTab } = useMobileLayoutStore()
  const ref = useRef<HTMLDivElement>(null)
  const language = useStore($language)
  useHeightObserver(ref, '--header-height')

  const showCountrySelect = language !== 'cn'

  return (
    <div
      ref={ref}
      style={{ top: 'calc(var(--navbarHeight) + var(--secondbarHeight))' }}
      className={cn(
        'sticky z-20 grid grid-cols-4 gap-[2px] border-b-4 border-rsf-white-background bg-rsf-white-background md:grid-cols-[repeat(auto-fit,_minmax(150px,_1fr))] pt-2',
        isMobile && activeMobileTab === 'deluxe' && 'grid-cols-4',
      )}
    >
      {showCountrySelect ? <CountrySelect /> : <div className="col-span-2 " />}
      <Hubs />
    </div>
  )
}
